import React, { useState, useEffect, useRef } from 'react';
import { FaChevronDown } from 'react-icons/fa';

export default function PlayerPicker({ players, value, onChange }) {
  const [playerInput, setPlayerInput] = useState(value || '');
  const [filteredPlayers, setFilteredPlayers] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const elRef = useRef();

  useEffect(() => {
    setPlayerInput(value || '');
  }, [value]);

  const filterPlayers = () => {

    if (players) {
      const lowerCaseInput = playerInput.toLowerCase();
      const matchingPlayers = players.filter(p => p.name.toLowerCase().includes(lowerCaseInput));

      setFilteredPlayers(matchingPlayers);
    } else {
      setFilteredPlayers([]);
    }
  }

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setPlayerInput(inputValue);
    onChange(inputValue);

    filterPlayers();
    setShowSuggestions(!!players?.length);
  };

  const handleInputClick = () => {
    setFilteredPlayers(players);
    setShowSuggestions(!!players?.length);
  };

  const handleButtonClick = (el) => {
    if (showSuggestions) {
      setShowSuggestions(false);
    } else {
      setFilteredPlayers(players);
      setShowSuggestions(true);
    }
  }

  const handleSelectPlayer = (player) => {
    setPlayerInput(player.name);
    onChange(player.name);
    elRef.current.focus();
    setShowSuggestions(false);
  };

  const handleBlur = (el) => {
    if (elRef.current && !elRef.current.contains(document.activeElement)) {
      setShowSuggestions(false);
    }
  }

  return (
    <div className='relative'>
      <div className="flex relative w-[150px]">
        <input
          ref={elRef}
          className='rounded-r-none flex-grow'
          type="text"
          value={playerInput}
          onChange={handleInputChange}
          onBlur={handleBlur}
          onClick={handleInputClick}
          onKeyDown={(e) => {
            if (e.key === 'Escape' && showSuggestions) {
              setShowSuggestions(false);
            }
            if (e.key === 'Enter' && showSuggestions && filteredPlayers.length > 0) {
              e.preventDefault();
              const firstItem = filteredPlayers[0]?.name;
              setPlayerInput(firstItem);
              onChange(firstItem);
              setShowSuggestions(false);
            }
          }}
          autoComplete="off"
        />
        <button
          type="button"
          className="flex items-center px-2 text-gray-400 hover:text-gray-200 rounded-l-none"
          onClick={handleButtonClick}
          onBlur={handleBlur}
          tabIndex={-1}
        >
          <FaChevronDown />
        </button>
      </div>
      {showSuggestions && (
        <ul className="absolute z-10 bg-white border border-gray-300 w-[150px] max-h-100 overflow-y-auto">
          {
            filteredPlayers?.map((p, index) => (
              <li
                key={p.name}
                className="p-1 cursor-pointer hover:bg-gray-400 player-suggestion-item"
                onMouseDown={(e) => {
                  e.preventDefault();
                  handleSelectPlayer(p);
                }}
                tabIndex="0"
              >
                {p.name}
              </li>
            ))
          }
          {
            players?.filter(v => !filteredPlayers.includes(v)).map((p, index) => (
              <li
                key={p.name}
                className="p-1 cursor-pointer hover:bg-gray-200 player-suggestion-item text-gray-400"
                onMouseDown={(e) => {
                  e.preventDefault();
                  handleSelectPlayer(p);
                }}
                tabIndex="0"
              >
                {p.name}
              </li>
            ))
          }
        </ul>
      )}
    </div>
  );
}
